<script type="text/javascript">
  export default {
    data() {
      return {
        showMessage: false,
        labelWidth: 100,
        loading: 0,
        isSubmiting: false
      }
    },
    props: {
      selection: {
        type: [Object, Array],
        default () {
          return {}
        }
      },
      okText: [String,Number],
      currentStep: Number,
      errorTip: {
        type: Boolean,
        default: true
      },
    },
    computed: {
      // 未更改的数据不提交到接口，这是真正要提交的数据
      _sendData() {
        return {
          ...(this.sendData || this.actionData),
          ...this.extraData
        }
      },
      isAndroid() {
        var u = navigator.userAgent;
        if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
          return true;
        } else {
          return false;
        }
      },
      isiOS() {
        var u = navigator.userAgent;
        if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          return true;
        } else {
          return false;
        }
      },
    },
    methods: {
      // 校验表单
      _validate() {
        return new Promise((resolve, reject) => {
          this.$children[0].validate(success => {
            this.showMessage = true
            window.setTimeout(() => {
              this.showMessage = false
            }, 3000)
            if (success) {
              resolve()
            } else {
              // eslint-disable-next-line
              reject()
            }
          })
        })
      },
      // 确认按钮
      _confirm() {
        var that = this
        that.isSubmiting = true
        this._validate().then(() => {
          if (typeof this.beforeSubmit === 'function') {
            this.beforeSubmit()
          }
          this.submit().then(rs => {
            if (rs.code == 200) {
              this.$emit('success', rs)
            } else {
              this.$emit('error', rs)
            }
          }).finally(() => {
            setTimeout(() => {
              that.isSubmiting = false
            },1000)
          })
        }).catch(error => {
          if(error&&this.errorTip) {
            this.$Message.error(error.toString())
          }
          setTimeout(() => {
            that.isSubmiting = false
          },1000)
        })
      },
      // 默认的提交方法，可在模板中改写
      submit: async function () {
        let rs = await this.$Ajax(this.url, this._sendData)
        return rs
      }
    },
    watch: {
      loading(count) {
        this.$emit('update:loading', count > 0)
      },
      isSubmiting(bool) {
        this.$emit('update:submitting', bool)
      }
    }
  }
</script>